import '../../assets/index6.css';var b = Object.defineProperty, P = Object.defineProperties;
var k = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, _ = Object.prototype.propertyIsEnumerable;
var s = (o, t, a) => t in o ? b(o, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : o[t] = a, c = (o, t) => {
  for (var a in t || (t = {}))
    l.call(t, a) && s(o, a, t[a]);
  if (r)
    for (var a of r(t))
      _.call(t, a) && s(o, a, t[a]);
  return o;
}, d = (o, t) => P(o, k(t));
var g = (o, t) => {
  var a = {};
  for (var e in o)
    l.call(o, e) && t.indexOf(e) < 0 && (a[e] = o[e]);
  if (o != null && r)
    for (var e of r(o))
      t.indexOf(e) < 0 && _.call(o, e) && (a[e] = o[e]);
  return a;
};
import { jsx as n, jsxs as p } from "react/jsx-runtime";
import { forwardRef as z } from "react";
import { Flex as w } from "../../components/Flex/index.js";
import { Group as u } from "../../components/Group/index.js";
import { c as y } from "../../factory-BnRIVbT0.js";
import { Button as f } from "../../components/Button/index.js";
import { Text as j } from "../../components/Text/index.js";
import { ArrowLeftFAIcon as A } from "../../components/Icons/index.js";
const I = "PageNavigation-module__root___aDzA-", D = "PageNavigation-module__container___IDieJ", F = "PageNavigation-module__backButton___I310z", G = "PageNavigation-module__title___Lgdb4", L = "PageNavigation-module__noBackButton___-C2lM", i = {
  root: I,
  container: D,
  backButton: F,
  title: G,
  noBackButton: L
}, J = z((M, h) => {
  var m = M, {
    title: o,
    onBackClick: t,
    classNames: a,
    actions: e,
    "data-plum-id": N
  } = m, B = g(m, [
    "title",
    "onBackClick",
    "classNames",
    "actions",
    "data-plum-id"
  ]);
  return /* @__PURE__ */ n(
    "div",
    d(c({
      ref: h,
      className: y(
        i.root,
        a,
        !t && i.noBackButton
      ),
      "data-plum-id": N
    }, B), {
      children: /* @__PURE__ */ n("div", { className: i.container, children: /* @__PURE__ */ p(w, { gap: "xxs", w: "100%", children: [
        t && /* @__PURE__ */ n(
          f,
          {
            variant: "tertiary",
            "aria-label": "Go back",
            size: "md",
            onClick: t,
            color: "gray",
            className: i.backButton,
            children: /* @__PURE__ */ n(A, { size: 16 })
          }
        ),
        /* @__PURE__ */ p(u, { justify: "space-between", align: "center", w: "100%", children: [
          /* @__PURE__ */ n(
            j,
            {
              className: i.title,
              component: "h1",
              size: "1.25rem",
              lh: 1.5,
              children: o
            }
          ),
          e && e.length > 0 && /* @__PURE__ */ n(u, { gap: "xs", children: e.map((v, x) => /* @__PURE__ */ n(
            f,
            c({
              size: "sm"
            }, v),
            x
          )) })
        ] })
      ] }) })
    })
  );
});
J.displayName = "PageNavigation";
export {
  J as PageNavigation
};
